import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { formatedDate, formateTTime } from "../../constants";
import { Description, SwipperComponent } from "../CustomComponents";
import ImageWithPlaceholder from "../CustomComponents/ImageWithPlaceholder";
import ModalContainer from "../ModalContainer";
import UserAvatarWithNameAndTag from "../UserAvatar/UserAvatarWithNameAndTag";
import cssStyles from "./styles/viewPostModal.module.scss";
import { useGetListingDetailsQuery } from "../../Data/services/listingApi";

const EventDetailModal = ({ handleViewModalClose, eventdata }) => {
  const { data: events, isLoading } = useGetListingDetailsQuery(eventdata?.id);
  const data = events?.data;

  return (
    <div>
      <ModalContainer handleClose={handleViewModalClose}>
        <div className={cssStyles.modalContainer}>
          {isLoading ? (
            <div className="h-100 d-flex align-items-center">
              <Spinner className="secondary-text" />
            </div>
          ) : (
            <>
              <div className="d-flex align-items-center w-100 justify-content-between mb-3">
                <p className="fs-4 fw-semibold m-0 black-text text-capitalize">
                  {data?.productTitle}
                </p>
                <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
                  <FaCircleXmark
                    role="button"
                    onClick={handleViewModalClose}
                    style={{ cursor: "pointer", color: "black" }}
                  />
                </span>
              </div>
              <Row className="w-100 h-100">
                <Col md={12} sm={12}>
                  <SwipperComponent
                    spaceBetween={10}
                    slidesPerView={1}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                  >
                    {data?.listing_media?.map((x) => (
                      <img
                        className={`${cssStyles.workoutImage} rounded`}
                        src={x?.mediaUrl}
                        alt="Event Image"
                        loading="lazy"
                        placeholder={"/images/placeholder.webp"}
                        style={{
                          maxHeight: "420px",
                          width: "100%",
                          objectFit: "contain",
                          backgroundColor: "black",
                        }}
                        key={x?.id}
                      />
                    ))}
                  </SwipperComponent>
                </Col>

                {/* Event Details */}
                <Col md={8} sm={12} className="mt-3">
                  <div className="d-flex flex-column justify-content-start align-items-top w-100 h-100">
                    <Description
                      classes="my-1 black-text"
                      text={`Created date: ${formatedDate(data?.createdAt)}`}
                    />
                    <Description classes="my-1 text-black-50" text="Location" />
                    <Description
                      classes="my-2 black-text"
                      text={`${data?.address || "Unknown Location"}`}
                    />
                    <Description
                      classes="my-1 text-black-50"
                      text="Equipment Details"
                    />
                    <Description
                      classes="my-2 black-text"
                      text={data?.equipmentDetails}
                    />
                    <hr />

                    <Description
                      classes="my-1 text-black-50"
                      text="Listing Document"
                    />
                    <Swiper
                      modules={[Navigation, Pagination, Scrollbar, A11y]}
                      spaceBetween={10}
                      loop={true}
                      className="main-slider h-100"
                      freeMode={true}
                      watchSlidesProgress={true}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      scrollbar={{ draggable: true }}
                    >
                      {data?.listing_documents?.map((x, index) => {
                        return (
                          <SwiperSlide key={index}>
                            <Description
                              classes="my-2 black-text"
                              text={
                                <>
                                  <div className="document-preview mb-3">
                                    {x.docUrl &&
                                    x.docUrl.match(/\.(jpeg|jpg|gif|png)$/) ? (
                                      <img
                                        src={x.docUrl}
                                        alt="Document Preview"
                                        style={{ border: "1px solid #ddd" }}
                                        title="Document Preview"
                                        width="100%"
                                        height="auto"
                                      />
                                    ) : (
                                      <iframe
                                        src={x.docUrl}
                                        alt="Document Preview"
                                        style={{
                                          border: "1px solid #ddd",
                                          overflow: "hidden",
                                        }}
                                        title="Document Preview"
                                        // width="100%"
                                        // height="auto"
                                      />
                                    )}
                                  </div>

                                  {/* Download Link */}
                                  <a
                                    href={x.docUrl}
                                    download
                                    className="text-decoration-none cursor-pointer"
                                    target="_blank"
                                  >
                                    Download Listing Document
                                  </a>
                                </>
                              }
                            />
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </Col>

                <Col md={4} sm={12} className="mt-3">
                  <UserAvatarWithNameAndTag
                    avatarImage={
                      data?.user?.user_images?.[0]?.image_url ||
                      "/images/user-placeholder.jpeg"
                    }
                    userName={data?.user?.displayName}
                  />

                  {/* Shipping Details Section */}
                  <div className="shipping-details mt-3">
                    {/* Shipping Information Header */}

                    {/* Shipping Address */}
                    <Description
                      classes="my-1 text-black-50"
                      text="Shipping Delivery"
                    />
                    <Description
                      classes="my-2 black-text"
                      text={data?.delivery || "-"}
                    />

                    {/* Contact Number */}
                    <Description
                      classes="my-1 text-black-50"
                      text="Shipping Cost"
                    />
                    <Description
                      classes="my-2 black-text"
                      text={`$ ${data?.shippingCost || 0}`}
                    />

                    {/* Shipping Status */}
                    <Description
                      classes="my-1 text-black-50"
                      text="Shipping Details"
                    />
                    <Description
                      classes="my-2 black-text"
                      text={data?.shippingDetails || "-"}
                    />
                    <div className="d-flex justify-content-between">
                      <div>
                        <Description
                          classes="my-1 text-black-50"
                          text="Half Day"
                        />
                        <Description
                          classes="my-2 black-text"
                          text={`$ ${data?.halfDay || 0}`}
                        />
                      </div>
                      <div>
                        <Description
                          classes="my-1 text-black-50"
                          text="Full Day"
                        />
                        <Description
                          classes="my-2 black-text"
                          text={`$ ${data?.fullDay || 0}`}
                        />
                      </div>
                      <div>
                        <Description classes="my-1 text-black-50" text="Week" />
                        <Description
                          classes="my-2 black-text"
                          text={`$ ${data?.week || 0}`}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      </ModalContainer>
    </div>
  );
};

export default EventDetailModal;
